var map = {
	"./1/symbol_0.png": 27521,
	"./1/symbol_1.png": 42904,
	"./1/symbol_10.png": 17226,
	"./1/symbol_11.png": 49139,
	"./1/symbol_12.png": 37176,
	"./1/symbol_2.png": 33747,
	"./1/symbol_3.png": 78538,
	"./1/symbol_4.png": 63205,
	"./1/symbol_5.png": 33788,
	"./1/symbol_6.png": 34423,
	"./1/symbol_7.png": 91406,
	"./1/symbol_8.png": 64441,
	"./1/symbol_9.png": 83888,
	"./2/symbol_0.png": 2740,
	"./2/symbol_1.png": 23869,
	"./2/symbol_10.png": 99401,
	"./2/symbol_11.png": 21280,
	"./2/symbol_12.png": 83259,
	"./2/symbol_2.png": 42662,
	"./2/symbol_3.png": 24207,
	"./2/symbol_4.png": 38832,
	"./2/symbol_5.png": 45081,
	"./2/symbol_6.png": 62146,
	"./2/symbol_7.png": 52651,
	"./2/symbol_8.png": 47612,
	"./2/symbol_9.png": 83525,
	"./3/symbol_0.png": 93799,
	"./3/symbol_1.png": 75486,
	"./3/symbol_10.png": 90012,
	"./3/symbol_12.png": 2542,
	"./3/symbol_2.png": 42837,
	"./3/symbol_3.png": 73740,
	"./3/symbol_4.png": 3907,
	"./3/symbol_5.png": 86330,
	"./3/symbol_6.png": 16497,
	"./3/symbol_7.png": 2280,
	"./3/symbol_8.png": 84543,
	"./3/symbol_9.png": 4566,
	"./4/symbol_0.png": 50098,
	"./4/symbol_1.png": 81275,
	"./4/symbol_10.png": 90707,
	"./4/symbol_12.png": 88462,
	"./4/symbol_2.png": 2944,
	"./4/symbol_3.png": 81065,
	"./4/symbol_4.png": 40982,
	"./4/symbol_5.png": 54271,
	"./4/symbol_6.png": 1060,
	"./4/symbol_7.png": 54957,
	"./4/symbol_8.png": 97178,
	"./4/symbol_9.png": 61283,
	"./gold1.png": 51013,
	"./gold2.png": 32238,
	"./gold3.png": 22231,
	"./gold4.png": 42616,
	"./silver1.png": 93726,
	"./silver2.png": 61077,
	"./silver3.png": 91980,
	"./silver4.png": 22147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36371;